import Input from '@material-ui/icons/Input';
import Tune from '@material-ui/icons/Tune';
import Edit from '@material-ui/icons/EditSharp';
import InsertDriveFile from '@material-ui/icons/InsertDriveFileOutlined';
import List from '@material-ui/icons/List';

import i18n from './utils/i18n';

export const tabRoutes = [
	{
		path: '/inputs',
		name: 'Inputs',
		text: i18n.t('pages.tabs.inputs'),
		tabId: 0,
		tabIcon: Input,
		disabled: false,
		snapshots: [{ id: 0, name: 'WebDesigner+™ Power Supply - INPUTS' }]
	},
	{
		path: '/select',
		name: 'Select',
		text: i18n.t('pages.tabs.select'),
		tabId: 1,
		tabIcon: Tune,
		disabled: true,
		snapshots: [{ id: 0, name: 'WebDesigner+™ Power Supply - SELECT' }]
	},
	{
		path: '/design',
		name: 'Design',
		text: i18n.t('pages.tabs.design'),
		tabId: 2,
		tabIcon: Edit,
		disabled: true,
		snapshots: [
			{
				id: 0,
				name: 'WebDesigner+™ Power Supply - DESIGN-SCHEMATIC'
			},
			{
				id: 1,
				name: 'WebDesigner+™ Power Supply - DESIGN-OPVALS'
			},
			{
				id: 2,
				name: 'WebDesigner+™ Power Supply - DESIGN-CHARTS'
			}
		]
	},
	{
		path: '/bom',
		name: 'BOM',
		text: i18n.t('pages.tabs.bom'),
		tabId: 3,
		tabIcon: InsertDriveFile,
		disabled: true,
		snapshots: [{ id: 0, name: 'WebDesigner+™ Power Supply - BOM' }]
	},
	{
		path: '/summary',
		name: 'Summary',
		text: i18n.t('pages.tabs.summary'),
		tabId: 4,
		tabIcon: List,
		disabled: true,
		snapshots: [{ id: 0, name: 'WebDesigner+™ Power Supply - SUMMARY' }]
	},
	{
		path: '/linksRedirect',
		name: 'LinksRedirect',
		tabId: 5,
		tabIcon: List,
		disabled: false,
		snapshots: [{ id: 0, name: 'WebDesigner+™ Power Supply - REDIRECT' }]
	}
];
